(function () {
  'use strict';
  if (window.essentiaPack7CartGuard) return;
  window.essentiaPack7CartGuard = true;
  var settings = window.ESSENTIA_PACK7_CART || {}, packId = Number(settings.packId) || 67942720634942;
  var allowed = new Set((settings.promoIds || [packId]).map(Number)); allowed.add(packId);
  var originalFetch = window.fetch.bind(window), active = Boolean(settings.inCart), toast, queue = Promise.resolve();
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function path(input) {
    try { var url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.origin); return url.origin === location.origin ? url.pathname : ''; }
    catch (error) { return ''; }
  }
  function isAdd(input) { return /\/cart\/add(?:\.js)?\/?$/.test(path(input)); }
  function isChange(input) { return /\/cart\/(change|update|clear)(?:\.js)?\/?$/.test(path(input)); }
  var incompatible = 'El Pack Árabe solo se puede combinar con los combos promocionales habilitados. Quitá el pack antes de agregar perfumes individuales.';
  function show(text) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'ea7-cart-guard__toast'; toast.setAttribute('role', 'alert'); document.body.appendChild(toast); }
    toast.replaceChildren();
    var span = document.createElement('span'), link = document.createElement('a');
    span.textContent = text; link.href = root + 'cart'; link.textContent = 'VER CARRITO';
    toast.append(span, link); toast.hidden = false;
  }
  function rejection(text) { show(text); return new Response(JSON.stringify({ status: 422, message: text, description: text }), { status: 422, headers: { 'Content-Type': 'application/json' } }); }
  function parse(body) {
    if (typeof body === 'string') {
      try { var data = JSON.parse(body); return (data.items || [data]).map(function (item) { return Number(item.id); }).filter(Boolean); }
      catch (error) { body = new URLSearchParams(body); }
    }
    var ids = [];
    if (body && typeof body.forEach === 'function') body.forEach(function (value, key) { if (key === 'id' || /^items\[\d+\]\[id\]$/.test(key)) ids.push(Number(value)); });
    return ids.filter(Boolean);
  }
  async function idsFor(input, init) {
    if (init && init.body) return parse(init.body);
    if (typeof Request !== 'undefined' && input instanceof Request) return parse(await input.clone().text());
    return [];
  }

  // Entry guard runs on the home CTA and every link to the selector. It is
  // separate from the cart/add guard, and uses the same Shopify cart snapshot.
  function entryProblem(cart) {
    var items = cart.items || [];
    if (items.some(function (item) { return Number(item.variant_id) === packId; }))
      return 'Ya tenés un Pack Árabe en el carrito. Finalizá tu compra o quitá el pack para armar otro.';
    if (items.some(function (item) { return !allowed.has(Number(item.variant_id)); }))
      return 'Tu carrito ya tiene decants individuales. Para armar el Pack Árabe, primero retirá esos decants. Los combos preparados sí están permitidos.';
    return '';
  }
  function syncEntryCards(cart) {
    var problem = entryProblem(cart);
    document.querySelectorAll('[data-ea7-pack-entry]').forEach(function (link) {
      if (!link.dataset.ea7PackOriginalHref) {
        link.dataset.ea7PackOriginalHref = link.getAttribute('href') || root + 'pages/arma-tu-pack-arabe';
        link.dataset.ea7PackOriginalHtml = link.innerHTML;
      }
      var home = link.closest('[data-ea7-pack-home]');
      var warning = home && home.querySelector('[data-ea7-pack-warning]');
      if (problem) {
        link.href = root + 'cart';
        link.textContent = 'VER CARRITO';
        link.dataset.ea7PackBlocked = 'true';
      } else {
        link.setAttribute('href', link.dataset.ea7PackOriginalHref);
        link.innerHTML = link.dataset.ea7PackOriginalHtml;
        link.dataset.ea7PackBlocked = 'false';
      }
      if (warning) { warning.textContent = problem; warning.hidden = !problem; }
    });
  }
  function isPackSelectorUrl(href) {
    try {
      var u = new URL(href, location.href);
      return u.origin === location.origin && /(?:^|\/)pages\/arma-tu-pack-arabe\/?$/.test(u.pathname);
    } catch (_) { return false; }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    // When blocked, the home CTA leads to the cart instead of the selector.
    if (link.dataset.ea7PackBlocked === 'true' && link.hasAttribute('data-ea7-pack-entry')) return;
    if (!isPackSelectorUrl(link.href)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var destination = link.href;
    readCart().then(function (cart) {
      var message = entryProblem(cart);
      if (message) show(message);
      else location.assign(destination);
    }).catch(function () {
      show('No pudimos verificar tu carrito. Reintentá antes de armar tu pack.');
    });
  }, true);
  async function readCart() {
    var response = await originalFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('No pudimos verificar el carrito. Reintentá en unos instantes.');
    var cart = await response.json();
    active = (cart.items || []).some(function (item) { return Number(item.variant_id) === packId; });
    document.documentElement.dataset.ea7Cart = String(active);
    syncEntryCards(cart);
    return cart;
  }
  async function blockReason(ids) {
    var cart = await readCart(), addingPack = ids.includes(packId);
    if (addingPack && settings.checkoutReady !== true) return 'El Pack Árabe todavía no está habilitado para comprar. Podés armar tu selección en la vista previa.';
    if ((active || addingPack) && (!ids.length || ids.some(function (id) { return !allowed.has(id); }))) return incompatible;
    if (addingPack && (cart.items || []).some(function (item) { return !allowed.has(Number(item.variant_id)); })) return 'Tenés perfumes individuales en el carrito. Quitálos antes de agregar el Pack Árabe; podés conservar los combos promocionales habilitados.';
    return '';
  }
  window.fetch = function (input, init) {
    if (isAdd(input)) {
      var execute = async function () {
        try { var reason = await blockReason(await idsFor(input, init)); if (reason) return rejection(reason); }
        catch (error) { return rejection(error.message || 'No pudimos verificar el carrito.'); }
        var response = await originalFetch(input, init);
        if (response.ok) await readCart().catch(function () {});
        return response;
      };
      var result = queue.then(execute, execute);
      queue = result.then(function () {}, function () {});
      return result;
    }
    return originalFetch(input, init).then(function (response) { if (isChange(input) && response.ok) readCart().catch(function () {}); return response; });
  };
  var approved = new WeakSet();
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !isAdd(form.action)) return;
    // Horizon already processes submit in its delegated handler. Its AJAX call
    // is protected by the fetch guard; resubmitting here would add twice.
    if (form.closest('product-form-component')) return;
    if (approved.has(form)) { approved.delete(form); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    var submitter = event.submitter;
    var check = async function () {
      try {
        var reason = await blockReason(parse(new FormData(form)));
        if (reason) { show(reason); return; }
        approved.add(form); form.requestSubmit(submitter || undefined);
      } catch (error) { show(error.message || 'No pudimos verificar el carrito.'); }
    };
    queue = queue.then(check, check);
  }, true);
  function refreshEntryCards() { readCart().catch(function () {}); }
  window.addEventListener('pageshow', refreshEntryCards);
  window.addEventListener('focus', refreshEntryCards);
  document.addEventListener('cart:update', refreshEntryCards);
  document.addEventListener('shopify:section:load', refreshEntryCards);
  refreshEntryCards();
})();
